import { Question } from "@src/components/Forms/PatientInformation/PatientInformation.helpers";

export const createAnswerObject = (questionData, questionsAnswers) => {

  const answerObject = {};
  const getAnswerIds = (questionShortName: string, answerKey: string) => {
    const question: Question | undefined = questionData?.find((q) => q.short_name === questionShortName);
    const questionID = question?.id;
    const answerIds = question?.options
      .filter((option) => questionsAnswers[answerKey].includes(option.short_name))
      .slice()
      .map((option) => option.id);
    return { questionID, answerIds };
  };

  Object.keys(questionsAnswers).forEach((answerKey) => {
    const { questionID, answerIds } = getAnswerIds(answerKey, answerKey);
    if (questionID) {
      answerObject[questionID] = answerIds;
    }
  });

  return answerObject
}
